import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";
import api from "../lib/api";

const AdminResetPassword = () => {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }
    if (pw !== pw2) {
      toast.error("Passwords do not match");
      return;
    }
    if (!token) {
      toast.error("Missing or invalid reset link");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please sign in.");
      nav("/admin/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#111111] text-white flex items-center justify-center px-6" data-testid="admin-reset-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-block bg-white/5 p-4 rounded-sm">
            <Logo className="h-14 w-14" showWordmark invert />
          </div>
          <div className="mt-6 overline text-[#7A1519]">Admin Portal</div>
          <h1 className="mt-2 font-display text-3xl tracking-tight font-semibold">Set a new password</h1>
        </div>

        <form onSubmit={submit} className="bg-white/5 border border-white/10 p-8 rounded-sm space-y-5">
          <div>
            <label className="overline text-white/50 block mb-2">New password</label>
            <input
              type="password"
              required
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="w-full bg-black/40 border border-white/10 px-4 py-3 rounded-sm text-sm outline-none focus:ring-1 focus:ring-[#7A1519]"
              data-testid="admin-reset-new"
              autoComplete="new-password"
              minLength={8}
            />
          </div>
          <div>
            <label className="overline text-white/50 block mb-2">Confirm new password</label>
            <input
              type="password"
              required
              value={pw2}
              onChange={(e) => setPw2(e.target.value)}
              className="w-full bg-black/40 border border-white/10 px-4 py-3 rounded-sm text-sm outline-none focus:ring-1 focus:ring-[#7A1519]"
              data-testid="admin-reset-confirm"
              autoComplete="new-password"
              minLength={8}
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            className="w-full bg-[#7A1519] hover:bg-[#5a0f12] text-white py-3.5 rounded-sm text-sm font-semibold tracking-wide disabled:opacity-50"
            data-testid="admin-reset-submit"
          >
            {busy ? "Updating…" : "Update password"}
          </button>
          <div className="text-center pt-2">
            <Link to="/admin/login" className="text-xs text-white/60 hover:text-white underline underline-offset-4">
              Back to sign in
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminResetPassword;
